"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var domElementHelper_1 = require("../helpers/domElementHelper");
var applyClassToJivo = function (isFilterOpen) {
    var jivoWidget = document.querySelector('jdiv');
    if (jivoWidget instanceof HTMLElement) {
        if (isFilterOpen) {
            domElementHelper_1.toggleClassName(jivoWidget, 'jivo-widget-disabled', 'add');
        }
        else {
            domElementHelper_1.toggleClassName(jivoWidget, 'jivo-widget-disabled', 'remove');
        }
    }
};
function useToggleDomElementStyle(isFilterOpen) {
    // Apply class when filter state changes
    react_1.useLayoutEffect(function () {
        applyClassToJivo(isFilterOpen);
        return function () {
            var jivoWidget = document.querySelector('jdiv');
            if (jivoWidget instanceof HTMLElement) {
                domElementHelper_1.toggleClassName(jivoWidget, 'jivo-widget-disabled', 'remove');
            }
        };
    }, [isFilterOpen]);
    // Watch for Jivo widget appearance in DOM
    react_1.useEffect(function () {
        // If filter is not open, no need to observe DOM
        if (!isFilterOpen)
            return;
        /**
         * MutationObserver is used to solve a race condition:
         * 1. When the page loads, the Jivo chat script loads asynchronously
         * 2. If a user opens filters before Jivo is loaded, the widget is not in DOM yet
         * 3. Without an observer, Jivo would appear on top of filters when it loads later
         * 4. This observer waits for the Jivo widget to appear in DOM and immediately hides it
         *    if filters are open, preventing it from appearing on top of filter elements
         */
        var observer = new MutationObserver(function (mutations) {
            // If jdiv (Jivo widget) appears, apply class
            if (document.querySelector('jdiv')) {
                applyClassToJivo(isFilterOpen);
                // After detection, disconnect observer
                observer.disconnect();
            }
        });
        // Start observing the entire body
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
        // Clean up observer on unmount
        return function () {
            observer.disconnect();
        };
    }, [isFilterOpen]);
}
exports.default = useToggleDomElementStyle;
